var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.$route.params.id)?_c('card-copy',{attrs:{"cardType":_vm.type,"cardId":_vm.$route.params.id}}):_c('card-maker',{attrs:{"cardType":_vm.type}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }